export default __webpack_public_path__ + "static/media/za.967b5908.svg";